<template>
    <div class="scenario-container">
        <b-list-group>
            <b-list-group-item v-for="(scenario, index) in filteredScenario" :key="index" title="">
                <div v-if="scenario.bonus_stage">
                    <component :is="gameNameOriginal" :scenarios="ticket.scenarios" :amount="ticket.amount">
                    </component>
                </div>
                <div v-else>
                    <div v-if="scenario.freespins">{{ 'freespin' | lang }} {{scenario.freespins.current}}/{{scenario.freespins.total}}</div>
                    <div class="d-flex justify-content-center pb-2">
                        <span v-if="scenario.reels" v-for="(symbols, reelIndex) in reelMap(scenario.reels)" :key="reelIndex">
                            <div v-for="(symbol, symbolIndex) in symbols" :key="symbolIndex" :class="symbol" :ref="`${ticket.id}_${index}_${reelIndex}_${symbolIndex}`" style="display: block;position: relative;">
                                <div alt="symbol" :style="$parent.getSymbolStyle(symbol, 50)"></div>
                            </div>
                        </span>
                    </div>
                    <div class="text-center">
                        <div class="scenario-line" v-for="(match, matchIndex) in scenario.matches" :key="matchIndex" 
                            @mouseleave="changeOpacity(ticket.id, index, 1)" @mouseenter="markMatch(ticket.id, match, index)">
                            <span v-if="match.line">{{ match.line }} {{ 'line' | lang }}</span>
                            <div style = "display: inline-block; position: relative;">
                                <div alt="symbol" :style="$parent.getSymbolStyle(match.symbol, 32)"></div>
                            </div>
                            <span>x{{ match.count }}</span>
                            <span v-if="match.type == 'row'">= {{ ticket.amount * (match.multiplier / scenario.lines_count) | currency }}</span>
                            <span v-else-if="match.type == 'table'">
                                = 
                                <span v-if="match.multiplier"> {{ ticket.amount * match.multiplier | currency }}</span><span v-if="match.multiplier && match.bonuses && match.bonuses.freespins && !index">, </span>
                                <span v-if="match.bonuses && match.bonuses.freespins && !index">{{ 'freespins' | lang }}({{match.bonuses.freespins}})</span>

                            </span>
                        </div>
                    </div>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>

import { range } from 'lodash';
import Book_of_einikis from './Games/BookOfEinikis';
import Vienas_namuose from './Games/VienasNamuose';

export default {
    props: ['ticket'],
    components: { Book_of_einikis, Vienas_namuose},
    data() {
        return {
            gameNameOriginal: Config.game_name,
            gameName: Config.game_name.toLowerCase(),
            height: Config.reels_height,
            width: Config.reels_width,
            paylines: Config.paylines,
        }
    },
    methods: {
        reelMap(reels) {
            if(!reels) {
                return;
            }

            const map = {};

            for (const [ index, step ] of Object.entries(reels)) {
                map[index] = this.reelSymbols(index, step);
            }

            return map;
        },
        reelSymbols(index, step) {
            const symbols = [];

            for (const relativeY of range(0, this.height)) {
                const absoluteIndex = step + relativeY;
                const reelLength = Config.reels[index].length;

                if (absoluteIndex < reelLength) {
                    symbols.push(Config.reels[index][absoluteIndex]);
                } else {
                    symbols.push(Config.reels[index][absoluteIndex - reelLength]);
                }
            }

            return symbols;
        },

        markMatch(ticket_id, match, scenarioIndex, opacity) {
            this.changeOpacity(ticket_id, scenarioIndex, 0.3);

            if(match.line) {
                for (const [ reelIndex, symbolPlace ] of Object.entries(this.paylines[match.line])) {
                    this.$refs[`${ticket_id}_${scenarioIndex}_${reelIndex}_${symbolPlace}`][0].style.opacity = 1;
                }
            } else {
                for(let i = 1; i <= this.width; i++) {
                    for(let y = 0; y < this.height; y++) {
                        if(this.$refs[`${ticket_id}_${scenarioIndex}_${i}_${y}`][0].classList.contains(match.symbol)) {
                            this.$refs[`${ticket_id}_${scenarioIndex}_${i}_${y}`][0].style.opacity = 1;
                        }
                    }
                }
            }
        },
        changeOpacity(ticket_id, scenarioIndex, opacity) {
            for(let i = 1; i <= this.width; i++) {
                for(let y = 0; y < this.height; y++) {
                   this.$refs[`${ticket_id}_${scenarioIndex}_${i}_${y}`][0].style.opacity = opacity;
                }
            }
        },
    },
    computed: {
        filteredScenario() {
            let list = [];

            //adding only one bonus stage scenario to avoid multiple prints, because we will pass whole scenarios to custom game history class
            for (const [ index, scenario ] of Object.entries(this.ticket.scenarios)) {
                list.push(scenario);

                if(scenario.bonus_stage) {
                    break;
                }
            }

            return list;
        }
    },
    mounted() {
    },
}
</script>
